import { render, staticRenderFns } from "./KeybeLabel.vue?vue&type=template&id=1232cadc&scoped=true&"
import script from "./KeybeLabel.vue?vue&type=script&lang=ts&"
export * from "./KeybeLabel.vue?vue&type=script&lang=ts&"
import style0 from "./KeybeLabel.vue?vue&type=style&index=0&id=1232cadc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1232cadc",
  null
  
)

export default component.exports